var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloatFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ql-fill",
    d: "M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ql-fill",
    d: "M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ql-fill",
    x: 2,
    y: 6,
    width: 14,
    height: 6,
    rx: 1,
    ry: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatFull);
export default __webpack_public_path__ + "static/media/float-full.928ea0b8deb9e17786f2bbcd77324de2.svg";
export { ForwardRef as ReactComponent };